export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7695.f3a104f1.jpg";